import React, { Component } from "react";
import axios from "axios";

import {
  GridContainer,
  PaginationContainer,
  MyVideoContainer
} from "../../MyVideo/MyVideo.style";
import Card from "../../Common/Card/Card";
import { MyUploadedVideoCardFooter } from "./MyUploadedVideoCardFooter"
import ThumbnailChangeDialog from "../ChangeThubnail";
import GalleryDialog from '../../../Gallery/GalleryDialog/GalleryDialog'
import ConfirmationDialog from "../../Common/ConfirmationDialog/ConfirmationDialog";
import { Pagination } from "../../Common/Pagination/Pagination";
import { EmptyLayerIcon } from "../../Common/SvgIcon/EmptyLayerIcon";
import { FinishedLayerIcon } from "../../Common/SvgIcon/FinishedLayerIcon";
import { GetBaseUrl, GetOriginalBaseUrl } from '@/utils/ConfigHelper'
import Loading from '@/Common/loading/loading'
import EmptyVideo from "../../MyVideo/emptyVideo/emptyVideo";
import OneBtnDialog from "../../../Common/OneBtnDialog/OneBtnDialog";
import { _onVideoLikedButtonClicked } from '../../../Routers/designSelect';
import i18n from '../../../i18n';
import ChangeTitleInput from '../../MyVideo/ChangeTitleInput/ChangeTitleInput';
import ShareDialog from "../../MyVideo/ShareDialog/ShareDialog";
import CopyToClipboard from 'copy-to-clipboard'
import { _getTemplateById } from '../../../Home';
import Uploading from '@/Common/Uploading/Uploading'

import TemplateHelper from '@/utils/TemplateHelper'
import { POINT_UI_EXPIRED_DATE, USER_SOURCE_UPLOAD_POLICY } from "@/utils/Global"

import { connect } from 'react-redux'
import { REDUX_ACTION } from '../../../Redux/action'
import { ReduxBinding } from '@/Redux/instance'

import { Logout } from '../../../Interface'
import NewGalleryDialog from "../../../Gallery/NewGalleryDialog";
import { getIsExpiredDate } from "@/utils/DateHelper";

class MyUploadedVideoClass extends Component {

  _isMounted = false

  state = {
    isDialogOpened: false,
    focusedDialogName: "",
    isBtnDialogOpened: false,
    dialogType: "failEditVideo",
    selectedVideoId: null,
    currentPage: 0,
    cardsPerPage: 15,
    myVideos: undefined,
    myVideosCount: 0,
    videoInfo: undefined,
    isGalleryDialogOpen: false,
    isOriginalDesignDialogOpened: false,
    getOriginalTemplateInfo: false,
    originalTemplate: {},

    isOpenSettingDropdown: false,
    isChangeTitleInputDialog: false,
    videoId: "",
    title: "",
    isShareDialogOpen: false,
    selectedVideo: {},
    selectedThumbnail: '',

    previews: [],

    isUploading: false,
    isNewGalleryDialogOpen: false,

    // GalleryDialog에서 다른 유저 비디오 누른 경우 뒤로가기 기능을 위해 데이터를 저장한다.
    stackedVideoIds: [],
    galleryDialogSameTemplateVideos: [],
  };

  templateGroupMap = {}

  getMyvideo = async () => {
    const token = localStorage.getItem('token');
    const pageIndex = this.state.currentPage
    const pageItemCount = this.state.cardsPerPage;

    const response = await axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${pageIndex}&limit=${pageItemCount}&filterId=${this.props.currentUser._id}`, { headers: { Authorization: `Bearer ${token}` } })

    this.setState({
      myVideos: response.data.videos,
      myVideosCount: response.data.itemCount
    })
  }

  GetVideoInfo = async _id => {
    const token = localStorage.getItem("token")
    const response = await axios.get(`${GetBaseUrl()}/api/video/gallery-detail?id=${_id}`, { headers: { Authorization: `Bearer ${token}` } })

    const videoInfo = response.data

    this.setState({ videoInfo })
    return videoInfo
  }

  async componentDidMount() {
    if (!this.props.isMounted) return
    this._isMounted = true
    this.getMyvideo()
  }

  openDialog = (focusedDialogName, videoId, layered) => event => {
    if (!layered) {
      return;
    }

    if (layered.state === "Rendering") {
      return;
    }

    if (layered.state === "Waiting") {
      return;
    }

    this.setState({
      isDialogOpened: true,
      focusedDialogName,
      selectedVideoId: videoId || null
    });
  };

  closeDialog = () => {
    this.setState({ isDialogOpened: false, focusedDialogName: "" });
  };

  getTemplateById = async (videoId) => {
    return _getTemplateById(videoId)
  };

  onThumbnailClicked = (video, templateId, layered, isEditable) => async e => {
    this.setState({ selectedVideo: video }, () => {
      this.OpenGalleryDialog(this.state.selectedVideo._id)
    })
  };

  OpenGalleryDialog = async (videoId) => {
    // const token = localStorage.getItem("token")
    const videoInfo = await this.GetVideoInfo(videoId)
    axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))

    try {
      // 다른 유저들이 만든 비디오 목록
      // let galleryDialogSameTemplateVideos = []
      // if (videoInfo && videoInfo.template) {
      //   const galleryInfo = await axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${0}&limit=${16}&templateId=${videoInfo.template._id}`, { headers: { Authorization: `Bearer ${token}` } })
      //   const { videos } = galleryInfo.data
      //   galleryDialogSameTemplateVideos = videos
      // }

      axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))
      this.setState({ isNewGalleryDialogOpen: true, galleryDialogSameTemplateVideos: [] });
    }
    catch (e) {
      console.log(e)
    }
  }

  moveOriginanlTemplate = async () => {
    if (this.state.videoInfo) {
      try {
        const res = await this.getTemplateById(this.state.videoInfo.template._id);

        if (!this.templateGroupMap[res[0].groupName]) {
          const groupResponse = await axios.post(`${GetBaseUrl()}/api/template/group-info`, { id: this.state.videoInfo.template._id })
          this.templateGroupMap[res[0].groupName] = groupResponse.data
        }

        this.setState({
          originalTemplate: res[0],
          getOriginalTemplateInfo: true,
          isOriginalDesignDialogOpened: true
        })
      }
      catch (e) {
        console.log(e)
      }
    }
  }

  handleClickGalleryDialogReturnBtn = () => {
    const { stackedVideoIds } = this.state

    if (stackedVideoIds.length === 0) return

    const lastVideoId = stackedVideoIds[stackedVideoIds.length - 1]
    const newStackedVideoIds = stackedVideoIds.filter(id => lastVideoId !== id)
    this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
      this.OpenGalleryDialog(lastVideoId)
    })
  }

  handleNewGalleryDialogClose = () => {
    this.setState({ isNewGalleryDialogOpen: false, stackedVideoIds: [] })
  }

  closeGalleryDialog = () => {
    this.setState({ isGalleryDialogOpen: false, stackedVideoIds: [] })
  }

  closeOrigianlDialog = () => this.setState({ isOriginalDesignDialogOpened: false, stackedVideoIds: [] })

  updateSelectedTemplate = async (templateId) => {
    const res = await this.getTemplateById(templateId)
    this.setState({ originalTemplate: res[0] })
  }

  onVideoLikedButtonClicked = (selectedVideo, likedVideos) => e => {
    _onVideoLikedButtonClicked(this, selectedVideo, likedVideos);
  };

  onVideoEditClicked = (videoId, templateId, layered, isEditable) => event => {
    this._onVideoEditClicked(videoId, templateId, layered, isEditable)
  }

  _onVideoEditClicked = async (videoId, templateId, layered, isEditable) => {
    try {
      const token = localStorage.getItem('token')
      const refreshtoken = localStorage.getItem('refreshtoken')

      await axios.get(`${GetBaseUrl()}/api/auth/refresh-verify?refreshtoken=${refreshtoken}`, { headers: { Authorization: `Bearer ${token}` } })
    }
    catch (e) {
      if (e && e.response && e.response.status === 401) {
        alert(i18n.t("global.expired.session"))
        Logout()
        this.props.history.push('/')
        return
      }
    }

    const token = localStorage.getItem("token");

    try {
      const videoRes = await axios.get(
        `${GetBaseUrl()}/api/user/myVideo?id=${videoId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        })

      if (!videoRes.data.data.isEditable) {
        this.setState({
          isBtnDialogOpened: true,
          dialogType: "noteditable"
        })
        return
      }

      const { paymentMode, currentUser } = this.props
      if (paymentMode || currentUser.admin) {
        this.videoEdit(videoId);
      }
      else {
        const res = await axios.post(
          `${GetBaseUrl()}/api/video/editable`,
          {
            _id: videoId
          },
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        )
        const { result } = res.data

        if (result === 'disableedit') {
          alert('myvideo.alert.block.edit.id')
        }
        else {
          if (result === 'success') {
            this.videoEdit(videoId);
          }
          else if (result === 'overtime') {
            this.setState({
              isBtnDialogOpened: true,
              dialogType: "overtime"
            })
          }
          else {
            this.setState({
              isBtnDialogOpened: true,
              dialogType: "failMoveEditVideoPage"
            })
          }
        }
      }

    }
    catch (e) {
      this.setState({
        isBtnDialogOpened: true,
        dialogType: "failMoveEditVideoPage"
      })
    }
  };

  onPageNumberClicked = newPage => event => {
    this.setState({ currentPage: newPage }, this.getMyvideo);
  };
  onPreviousPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, this.getMyvideo);
  };
  onNextPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, this.getMyvideo);
  };
  videoEdit = (videoId) => {
    this.props.history.push({ pathname: `/makevideo`, search: `?id=${videoId}`, state: { edit: true } });
  }
  onViewAllFreeVideosButtonClicked = () => {
    const { history } = this.props
    history.push("/designselect");
  }
  popupHandleCloseBtn = () => {
    this.setState({
      isBtnDialogOpened: false
    })
  }

  SettingClick = (id, layered) => {
    if (!layered) {
      return;
    }

    if (layered.state === "Rendering") {
      return;
    }

    if (layered.state === "Waiting") {
      return;
    }

    this.setState({
      isOpenSettingDropdown: !this.state.isOpenSettingDropdown,
      videoId: id
    })
  }

  handleClickAway = () => {
    this.setState({
      isOpenSettingDropdown: false,
    })
  }
  // 제목변경 팝업 열기
  handleChangeTitle = (video) => {
    this.setState({ isChangeTitleInputDialog: true, selectedVideo: video })
  }
  // 제목변경 팝업 닫기
  closeChangeTitleInputDialog = () => {
    this.setState({ isChangeTitleInputDialog: false })
  }

  handleOpenThumbnailDialog = async (_id, thumbnail) => {
    try {
      const token = localStorage.getItem("token")
      const response = await axios.get(`${GetBaseUrl()}/apis/videos/${_id}/previews`, { headers: { Authorization: `Bearer ${token}` } })

      const previews = response.data.data

      this.setState({
        selectedVideoId: _id,
        previews,
        selectedThumbnail: thumbnail,
        isDialogOpened: true,
        focusedDialogName: 'ThumbnailDialog'
      })
    }
    catch (e) {
      alert('Error')
    }
  }

  handleAddCustomThumbnail = e => {
    const { uploadImgBloburl } = this.props
    if (e.target.files[0].size > USER_SOURCE_UPLOAD_POLICY.LimitSize.Thumbnail) {
      alert(i18n.t("web.changethumbnail.direct-image-upload.description")
        .replace("{LIMIT}", USER_SOURCE_UPLOAD_POLICY.LimitSize.Thumbnail / 1024 / 1024))
    }
    else {
      const src = URL.createObjectURL(e.target.files[0])

      const image = new Image()
      image.src = src

      image.onload = () => {
        const max = Math.max(image.width, image.height)
        const min = Math.min(image.width, image.height)

        if (max / min > 2) return alert(i18n.t("web.changethumbnail.direct-image-upload.invalid.ratio"))

        uploadImgBloburl.push(src)
        ReduxBinding(REDUX_ACTION.UPLOAD_IMG_BLOBURL, [...uploadImgBloburl])
      }
    }
    e.target.value = ''
  }

  handleChangeThumbnail = async (_id, index, type) => {
    try {
      const { uploadImgBloburl } = this.props
      const { myVideos, previews } = this.state
      this.closeDialog()

      let url
      const token = localStorage.getItem("token")
      if (type === 'previews') {
        url = previews[index]
        await axios.patch(`${GetBaseUrl()}/apis/videos/${_id}/thumbnail`, { index }, { headers: { Authorization: `Bearer ${token}` } })
      }
      else if (type === 'custom') {
        url = uploadImgBloburl[index]

        const response = await axios.get(url, { responseType: 'blob' })
        const blob = response.data

        const formData = new FormData()
        formData.append('source', blob, `${Date.now()}.${blob.type.split('/')[1]}`)

        this.setState({ isUploading: true })

        const regionResponse = await axios.get(
          `${GetBaseUrl()}/apis/videos/${_id}/region`,
          { headers: { Authorization: `Bearer ${token}` } }
        )

        await axios.post(`${GetOriginalBaseUrl(regionResponse.data.data.region)}/apis/videos/${_id}/thumbnail/upload`, formData, { headers: { Authorization: `Bearer ${token}` } })
      }

      for (let i = 0; i < myVideos.length; i++) {
        if (myVideos[i]._id === _id) {
          myVideos[i].thumbnailURL = url
          break
        }
      }
      this.setState({ myVideos })
    }
    catch (e) {
      alert('Error')
    }
    this.setState({ isUploading: false })
  }

  changeTitle = (event) => {
    this.setState({ title: event.target.value });
  }
  onTitleSubmitButtonClicked = () => {
    if (this.state.title.length === 0) {
        return alert(i18n.t("examineshopdialog.placeholder.title"));
    }
    const token = localStorage.getItem("token");
    let _id = this.state.selectedVideo._id
    const axiosResult = axios.post(
      `${GetBaseUrl()}/api/video/rename`,
      {
        _id,
        name: this.state.title
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    axiosResult
      .then(res => {
        const { myVideos, title: name } = this.state
        if (myVideos) {
          for (let i = 0; i < myVideos.length; i++) {
            if (myVideos[i]._id === _id) {
              myVideos[i].name = name
              break
            }
          }
        }

        this.setState({ myVideos, isChangeTitleInputDialog: false, videoId: "", title: "" });
      })
      .catch(error => {
        alert(i18n.t("onebtndialog.failEditVideo.dialogBodyText2"), error);
      });
  }
  // 공유 버튼 클릭시 활성화 되는 팝업창
  handleClickShareIcon = (video) => {
    this.setState({ isShareDialogOpen: true, selectedVideo: video })
  }
  //공유 팝업창 끄는 함수
  closeShareDialog = () => {
    this.setState({ isShareDialogOpen: false })
  }

  clickShareItem = async method => {
    const item = this.state.selectedVideo
    if (item.state === 'Empty' || item.state === 'Rendering' || item.state === 'Waiting') return
    try {
      const response = await axios.get(`${GetBaseUrl()}/api/video/share-link?id=${item._id}`)
      if (response && response.data && response.data.result === 'success') {
        const { shareId } = response.data
        const shareLink = window.location.origin + `/share?id=${shareId}`
        const { invokeCSharpAction } = window
        const isXamarin = invokeCSharpAction

        switch (method) {
          case 'twitter':
          case 'facebook':
            let targetLink = 'about:blank'

            if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
            else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

            if (isXamarin) window.location.href = targetLink
            else {
              const windowRef = window.open(targetLink, '_blank')
              if (!windowRef) this.setState({
                isBtnDialogOpened: true,
                dialogType: "shareLinkBlock"
              })
            }
            break

          case 'linkxamarin':
            window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
            break

          case 'link':
          default:
            CopyToClipboard(shareLink)
            this.setState({
              isBtnDialogOpened: true,
              dialogType: "shareSuccess"
            })
            break
        }
      }
    }
    catch (e) {
      this.setState({
        isBtnDialogOpened: true,
        dialogType: "shareFail"
      })
    }
  }

  handleGalleryUploadDialogOpen = async video => {
    if (!video) return

    try {
      const isGalleryOpen = Boolean(video.isGalleryOpen)
      const focusedDialogName = !isGalleryOpen ? "GalleryUpload" : "GalleryUploadCancel"

      this.setState({ selectedVideo: video })
      this.openDialog(focusedDialogName, video._id, video)()
    }
    catch (e) {

    }
  }

  galleryUpload = () => async () => {
    const { selectedVideo: video } = this.state
    if (!video) return
    // if (video.isUsedMyMusic) return alert(i18n.t("web.gallery.used.custom.music"))

    const token = localStorage.getItem("token");
    let { myVideos } = this.state
    let isGalleryUpload;
    if (video.isGalleryOpen) {
      isGalleryUpload = false
    } else {
      isGalleryUpload = true
    }
    try {
      await axios.post(`${GetBaseUrl()}/api/video/gallery-open`,
        {
          id: video._id,
          isOpen: isGalleryUpload
        },
        { headers: { Authorization: `Bearer ${token}` } });
      if (isGalleryUpload) {
        this.setState({
          isBtnDialogOpened: true,
          dialogType: "galleryUploadSuccess"
        })
      } else {
        this.setState({
          isBtnDialogOpened: true,
          dialogType: "galleryDelete"
        })
      }
      for (let i = 0; i < myVideos.length; i++) {
        if (myVideos[i]._id === video._id) {
          myVideos[i].isGalleryOpen = isGalleryUpload
          this.setState({
            myVideos
          })
        }
      }
      this.props.getUsersAggregate()
    } catch (err) {
      console.log(err)
    }
    this.closeDialog()
  }

  getVideoThumbnailImage = video => {
    if (video.thumbnailURL) {
      if (video.thumbnailURL.startsWith('blob:')) return video.thumbnailURL
      else return TemplateHelper.ConvertURLToSmallURL(video.thumbnailURL)
    }
    if (video.template) return TemplateHelper.getThumbnailImage(video.template, video.lang, true)
    return ""
  }

  heartClick = async (id, e) => {
    e.stopPropagation()
    const token = localStorage.getItem("token");
    const { videoInfo } = this.state
    if (token) {
      try {
        if (videoInfo) {
          if (!videoInfo.isLike) {
            videoInfo.isLike = true
            videoInfo.likeMembers++
            this.setState({ videoInfo, date: Date.now() })
            await axios.post(`${GetBaseUrl()}/api/video/set-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
          }
          else {
            videoInfo.isLike = false
            videoInfo.likeMembers--
            this.setState({ videoInfo, date: Date.now() })
            await axios.post(`${GetBaseUrl()}/api/video/unset-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
          }
        }
      }
      catch (e) {
        this.setState({
          dialogType: "severError",
          isBtnDialogOpened: true
        })
      }
    } else {
      this.loginRequest()
    }
  }

  handleClickHashtag = (hashtag) => {
    const nxtPath = `/gallery`

    if (!hashtag || nxtPath === window.location.pathname) return

    this.props.history.push(nxtPath, { hashtag: hashtag.replace('#', '') })
  }

  handleUpdateVideoHashTag = async (hashtagString) => {
    const { videoInfo, myVideos } = this.state

    const token = localStorage.getItem("token");
    const _id = videoInfo._id

    try {
      let hashtag = ''
      if (hashtagString === '#') {
        hashtag = ''
      }
      else {
        hashtagString.split('#').forEach((tag, idx) => {
          if (idx > 0) {
            hashtag += (idx === 1) ? `#${tag}` : ` #${tag}`
          }
        })
      }

      const res = await axios.patch(
        `${GetBaseUrl()}/apis/videos/${_id}/hashtag`,
        { hashtag },
        { headers: { Authorization: `Bearer ${token}` } })

      if (res.data.message === 'success') {
        let newMyVideos = myVideos.map((v, idx) => {
          if (v._id === videoInfo._id) {
            v.hashtag = hashtag
          }
          return v
        })

        this.setState({ hashtagString: '', myVideos: newMyVideos }, () => {
          const videoInfo = this.GetVideoInfo(_id)
          this.setState({ videoInfo, date: Date.now() })
        })
      }
    }
    catch (e) {
      console.log(e)
    }
  }

  handleClickGoSeeMoreVideos = (templateId) => {
    const curTemplateId = templateId
    this.props.history.push({
      pathname: '/gallery',
      state: {
        curTemplateId
      }
    })
  }

  handleClickSameTemplate = (videoId) => {
    const { stackedVideoIds, videoInfo } = this.state
    if (!videoId || !videoInfo || videoId === videoInfo._id) return

    try {
      const newStackedVideoIds = stackedVideoIds.map(e => e)
      newStackedVideoIds.push(videoInfo._id)

      this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
        this.OpenGalleryDialog(videoId)
      });
    }
    catch (e) {
      console.log(e)
      return null
    }
  }

  render() {
    const Waiting = {
      state: "Waiting",
      iconUrl: "https://front.videomonster.com/images-u6yd72dy/web/myvideo/waiting.png",
      text: i18n.t("myvideo.waiting.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.waiting.title"),
        message:
          i18n.t("myvideo.waiting.message")
      }
    };
    const Rendering = {
      state: "Rendering",
      iconUrl: "",
      text: i18n.t("myvideo.rendering.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.rendering.title"),
        message:
          i18n.t("myvideo.rendering.message")
      }
    };

    const Finish = {
      state: "Finish",
      iconUrl: FinishedLayerIcon,
      text: i18n.t("myvideo.finish.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.finish.title"),
        message:
          i18n.t("myvideo.finish.message")
      }
    }

    const Empty = {
      state: "Empty",
      iconUrl: EmptyLayerIcon,
      text: i18n.t("myvideo.empty.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.empty.title"),
        message:
          i18n.t("myvideo.empty.message")
      }
    }

    const ErrorState = {
      state: "Error",
      iconUrl: '',
      text: i18n.t("myvideo.error.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.error.title"),
        message:
          i18n.t("myvideo.error.message1_1") +
          i18n.t("myvideo.error.message1_2") +
          i18n.t("myvideo.error.message1_3")
      }
    }

    const renderStateTable = {
      Empty,
      Waiting,
      Rendering,
      Finish,
      Error: ErrorState
    };
    const {
      myVideos,
      videoInfo,
      isOriginalDesignDialogOpened,
      originalTemplate,
      getOriginalTemplateInfo,
      date,
      galleryDialogSameTemplateVideos,
      stackedVideoIds,
      isNewGalleryDialogOpen
    } = this.state;
    let { currentPage, cardsPerPage, myVideosCount } = this.state;

    if (myVideos) {
      let maxPageCount = Math.floor((myVideosCount - 1) / cardsPerPage)
      if (maxPageCount < 0) maxPageCount = 0
      if (currentPage > maxPageCount) currentPage = maxPageCount
    }

    if (myVideos === undefined) {
      return <Loading />;
    }
    if (myVideos.length === 0) {
      return <EmptyVideo
        onViewAllFreeVideosButtonClicked={this.onViewAllFreeVideosButtonClicked}
        text1={i18n.t("myvideo.emptyvideo.text1")}
        text2={i18n.t("myvideo.emptyvideo.text2")}
        img="https://front.videomonster.com/images-u6yd72dy/web/Empty-icon.png"
        btn={true}
      >
      </EmptyVideo>;
    }
    const selectedVideo = myVideos.filter(
      video => video._id === this.state.selectedVideoId
    )[0];
    const renderStateTableData = selectedVideo
      ? renderStateTable[selectedVideo.state]
      : undefined

    const isPointUiShow = getIsExpiredDate(POINT_UI_EXPIRED_DATE);

    return (
      <MyVideoContainer>
        <div style={{ maxWidth: "1200px", margin: "auto", minHeight: "351px" }}>
          <GridContainer>
            {myVideos
              .map(video => {
                const layered = renderStateTable['Finish'];
                const date = formatDate(video.date);
                video.state = 'Finish'

                return (
                  <Card
                    myvideo
                    video={video}
                    key={video._id}
                    title={
                      video.name === ""
                        ? video.template && video.template.name
                        : video.name
                    }
                    date={date || ""}
                    thumbnailUrl={this.getVideoThumbnailImage(video)}
                    onThumbnailClicked={this.onThumbnailClicked(
                      video,
                      (video.template && video.template._id) || ''
                    )}
                    onClickShareIcon={this.handleClickShareIcon}
                    onChangeTitle={this.handleChangeTitle}
                    layered={layered}
                    showGalleryIcons={true}
                    settingIcon={
                      <MyUploadedVideoCardFooter
                        video={video}
                        onSettingClicked={(e) => this.SettingClick(video._id, layered)}
                        id={this.state.videoId}
                        show={this.state.isOpenSettingDropdown}
                        onChangeTitle={this.handleChangeTitle}
                        onChangeThumbnail={this.handleOpenThumbnailDialog}
                        onShare={this.handleClickShareIcon}
                        onRemoveWaterMark={() => { }}
                        galleryUpload={this.handleGalleryUploadDialogOpen}
                        handleClickAway={this.handleClickAway}
                        thumbnailUrl={this.getVideoThumbnailImage(video)}
                      />
                    }
                  />
                );
              })}
          </GridContainer>

        </div>

        <ThumbnailChangeDialog
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "ThumbnailDialog"
          }
          selectedVideo={selectedVideo}
          renderStateTableData={renderStateTableData}
          thumbnailImg={this.state.selectedThumbnail}
          customThumbnails={this.props.uploadImgBloburl}
          previews={this.state.previews}
          handleAddCustomThumbnail={this.handleAddCustomThumbnail}
          handleChangeThumbnail={this.handleChangeThumbnail}
        />
        <PaginationContainer>
          <Pagination
            currentPage={currentPage}
            cardsPerPage={cardsPerPage}
            itemCount={this.state.myVideosCount}
            onPageNumberClicked={this.onPageNumberClicked}
            onPreviousPageClicked={this.onPreviousPageClicked}
            onNextPageClicked={this.onNextPageClicked}
          />
        </PaginationContainer>

        <OneBtnDialog
          dialogType={this.state.dialogType}
          open={this.state.isBtnDialogOpened}
          closeBtn={this.popupHandleCloseBtn}
          onButtonClick={this.popupHandleCloseBtn}
        />

        <ChangeTitleInput
          open={this.state.isChangeTitleInputDialog}
          onClose={this.closeChangeTitleInputDialog}
          onTitleSubmitButtonCancel={this.closeChangeTitleInputDialog}
          onChange={this.changeTitle}
          onTitleSubmitButtonClicked={this.onTitleSubmitButtonClicked}
          video={this.state.selectedVideo}
        />
        <ShareDialog
          open={this.state.isShareDialogOpen}
          onClose={this.closeShareDialog}
          onShare={this.clickShareItem}
        />

        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("web.myvideo.gallery.upload.btn")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "GalleryUpload"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.galleryUpload}
          title={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.upload.ask.title")
              : i18n.t("web.myvideo.gallery.new.upload.ask.title")
          }
          message={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.upload.ask.body")
              : null
          }
        />
        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("web.myvideo.gallery.delete.btn")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "GalleryUploadCancel"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.galleryUpload}
          title={i18n.t("web.myvideo.gallery.delete.ask.title")}
          message={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.delete.ask.body")
              : null
          }
        />

        {/* <GalleryDialog
          {...this.props}
          open={this.state.isGalleryDialogOpen}
          videoInfo={videoInfo}
          isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
          moveOriginanlTemplate={this.moveOriginanlTemplate}
          templateGroupMap={this.templateGroupMap}
          originalTemplate={originalTemplate}
          getOriginalTemplateInfo={getOriginalTemplateInfo}
          closeGalleryDialog={this.closeGalleryDialog}
          closeOrigianlDialog={this.closeOrigianlDialog}
          updateSelectedTemplate={this.updateSelectedTemplate}
          onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
          loginRequest={() => { }}
          clickShareItem={this.clickShareItem}
          updateVideoInfo={this.GetVideoInfo}
          heartClick={this.heartClick}
          date={date}
          onClickSameTemplate={this.handleClickSameTemplate}
          onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
          onUpdateHashTag={this.handleUpdateVideoHashTag}
          onClickHashTag={this.handleClickHashtag}
          galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
          stackedVideoIds={stackedVideoIds}
        /> */}

        <NewGalleryDialog
          {...this.props}
          open={isNewGalleryDialogOpen}
          onClose={this.handleNewGalleryDialogClose}
          videoInfo={videoInfo}
          loginRequest={() => { }}
          clickShareItem={this.clickShareItem}
          updateVideoInfo={this.GetVideoInfo}
          heartClick={this.heartClick}
          moveOriginanlTemplate={this.moveOriginanlTemplate}
          isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
          templateGroupMap={this.templateGroupMap}
          originalTemplate={originalTemplate}
          getOriginalTemplateInfo={getOriginalTemplateInfo}
          closeOrigianlDialog={this.closeOrigianlDialog}
          updateSelectedTemplate={this.updateSelectedTemplate}
          onClickSameTemplate={this.handleClickSameTemplate}
          galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
          onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
          onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
          stackedVideoIds={stackedVideoIds}
          onClickReturnBtn={this.handleClickGalleryDialogReturnBtn}
          onClickHashTag={this.handleClickHashtag}
          onUpdateHashTag={this.handleUpdateVideoHashTag}
          date={date}
        />

        <Uploading open={this.state.isUploading} />
      </MyVideoContainer>
    );
  }
}

export const formatDate = videoDate => {
  const date = new Date(videoDate);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
  const finalDate = dateString.replace(/-/g, ".");
  return finalDate;
};

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  value: state.langStore.lang,
  paymentMode: state.paymentModeStore.paymentMode,
  uploadImgBloburl: state.uploadImgBloburlStore.uploadImgBloburl
})

export const MyUploadedVideo = connect(mapStateToProps, null)(MyUploadedVideoClass)